angular.module("vgresiduos").controller("RecipientEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `unidade/acondicionamento/${$stateParams.id}`);
		};
	}
]);
